

































































import { Intervention } from "../../models/Intervention";
import Facturation = Intervention.Facturation;

export default {
    name: "FacturationModalDisplay",
    props: {
        facturation: Facturation,
    },
};
